import { render, staticRenderFns } from "./Broadcasts.vue?vue&type=template&id=f6a8cf9a&"
import script from "./Broadcasts.vue?vue&type=script&lang=js&"
export * from "./Broadcasts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports